import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

//Fix for iOS when navigate back and the content has not yet been rendered
const useScrollHack = () => {
  const { hash } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    }, 10);
    
  }, [hash]);
};

export default useScrollHack;
